import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-btn">
          <FiArrowLeft />
          Back to Home
        </Link>
        
        <div className="policy-content">
          <h1>Privacy policy</h1>
          
          <section>
            <h2>Your Privacy: Our Commitment</h2>
            <p>
              At ShantiSilks.com, we are deeply committed to protecting your privacy. We understand and value the trust you place in us, and we promise to use the information we collect only to provide you with a more personalized and seamless shopping experience. Our goal is to earn your confidence, so you feel enthusiastic about using our services and recommending us to your friends and family.
            </p>
            <p>
              Please read this policy to understand how your personal information is handled, ensuring you can fully enjoy everything ShantiSilks.com has to offer.
            </p>
          </section>

          <section>
            <h2>ShantiSilks.com Privacy Guarantee</h2>
            <p>
              We will never rent, sell, share, or misuse your personally identifiable information collected during your use of our website, except as explicitly agreed to by you. While we may occasionally share general statistics about our website and visitors (like the number of visitors or types of products purchased), we will never identify you by name or specific address. Your trust is our highest priority.
            </p>
          </section>

          <section>
            <h2>Information We Collect From You</h2>
            <p>
              When you use our services, we collect and store your personal information to provide you with an efficient, smooth, and customized experience. This helps us offer features and services that best meet your needs and make your experience quicker and easier.
            </p>
            <p>
              To fully use our services, you'll need to register using our online form, where we'll ask for your contact and other personal details. You might also provide us with a ShantiSilks ID.
            </p>
            <p>
              We may automatically track certain information about your behavior on our site to better understand our users' demographics, interests, and overall site usage. This information, compiled and analyzed in an aggregated (non-identifiable) way, can include the URLs you visit (before and after our site), your browser type, IP address, and your shopping activities. We also collect comments from other users about you in our feedback area. If you send us personal correspondence (like emails or letters) or if others send us correspondence about your activities on the site, we may collect this information into a file specific to you.
            </p>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>
              The information we collect helps us enhance your experience by building features that make using our service easier and more personal. This includes:
            </p>
            <ul>
              <li>Faster purchase requests</li>
              <li>Improved customer support</li>
              <li>Better product offerings</li>
              <li>Timely notifications of new ShantiSilks.com services and special offers</li>
            </ul>
            <p>
              We believe these uses help us refine our site to better meet your needs. We may also use your information to send you targeted information, such as new services and promotions. By accepting our User Agreement, you agree to receive these communications. We use your email, mailing address, and phone number to contact you about administrative notices, new products, and communications relevant to your site usage.
            </p>
          </section>

          <section>
            <h2>Disclosure of Your Information</h2>
            <p>
              We may share your information in specific circumstances to deliver targeted information, like new services and promotions, or for site security. Here are examples of categories of persons with whom we might share your information:
            </p>
            
            <h3>1. Advertisements:</h3>
            <ul>
              <li>
                If you enter information on an advertiser's form, that information is collected by both ShantiSilks.com and the advertiser simultaneously. ShantiSilks.com uses this information according to this privacy policy, while the advertiser uses it according to their own policies. We recommend reviewing their privacy practices before providing information.
              </li>
              <li>
                We may also aggregate (combine data across all user accounts) personally identifiable information and share this non-personally identifiable data with advertisers and other third parties for marketing and promotional purposes.
              </li>
            </ul>

            <h3>2. Classifieds Listings:</h3>
            <ul>
              <li>
                If you list a classified ad and an interested user expresses interest, that user will receive your contact information as provided in your registration form.
              </li>
              <li>
                If you express interest in a classified ad, the user who listed the ad will receive your contact information as provided in your registration form.
              </li>
            </ul>

            <h3>3. Third-Party Services:</h3>
            <ul>
              <li>
                For certain items and services offered on our site in conjunction with third parties (e.g., home loan applications), the information you provide is collected by both ShantiSilks.com and the respective third party. This information is used by the third party according to their privacy policy and offer terms. We advise you to evaluate their privacy practices before using their services, as we do not control them.
              </li>
            </ul>

            <h3>4. Internal Service Providers:</h3>
            <ul>
              <li>
                We may engage internal service providers (e.g., for research, surveys, data mining) and may share some of your personally identifiable information with them. In some cases, they might collect information directly from you (e.g., for a research survey). In such instances, you will be notified of their involvement, and any information you disclose will be strictly optional. These providers are bound by confidentiality agreements regarding the information we supply. If you provide additional information directly to them, their privacy policy will govern its use. We encourage you to review their practices before providing information.
              </li>
            </ul>
            <p>
              We also collect information from you to prevent misuse of data by machines and to protect our site from hacking attempts.
            </p>
          </section>

          <section>
            <h2>How We Protect Your Information</h2>
            <p>
              When you place orders or access your account, we utilize a secure server. Our secure server software (SSL) encrypts all information you input before it's sent to us. Furthermore, all customer data we collect is protected against unauthorized access.
            </p>
          </section>

          <section>
            <h2>Children's Privacy</h2>
            <p>
              Our services are not intended for children. We request that minors (under 18 years of age) do not submit any personal information to us. If you are a minor, you may use this service only with the supervision of your parents or guardians.
            </p>
          </section>

          <section>
            <h2>Accessing or Changing Your Personal Information</h2>
            <p>
              To protect your privacy and security, we will verify your identity before granting access or making changes to your personally identifiable information. If you have registered a profile on ShantiSilks.com, your ShantiSilks ID and Password are required to access your profile details.
            </p>
          </section>

          <section>
            <h2>Security Measures</h2>
            <p>
              We employ reasonable and current Internet security methods and technologies to prevent unauthorized access, maintain data accuracy, and ensure the correct use of information. Any changes to our privacy policy will be announced on our website at least 10 days before they are implemented. Information collected before any changes will remain secured according to the previous privacy policy.
            </p>
          </section>

          <section>
            <h2>Your Consent</h2>
            <p>
              By using our website, you consent to the collection and use of your information by ShantiSilks.com. Should we decide to change our privacy policy, we will post those changes on this page. This ensures you are always aware of what information we collect, how we use it, and under what circumstances we disclose it.
            </p>
          </section>

          <section>
            <h2>Share Your Thoughts</h2>
            <p>
              We welcome your questions and comments regarding our privacy policy. Please feel free to email us at help@ShantiSilks.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

